"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useStyles = themeColors => {
  // default theme-1 styles

  const [theme, setTheme] = (0, _react.useState)("white");
  const [backgroundColor, setBackgroundColor] = (0, _react.useState)("#FFFFFF");
  const [color, setColor] = (0, _react.useState)("#252A2E");
  const [ctaOne, setCtaOne] = (0, _react.useState)("primary--1");
  const [ctaTwo, setCtaTwo] = (0, _react.useState)("secondary--2");
  const [iconColor, setIconColor] = (0, _react.useState)("#252A2E");
  const [accordionIconColor, setAccordionIconColor] = (0, _react.useState)("#0063A3");
  (0, _react.useEffect)(() => {
    const updateThemeColors = () => {
      if (themeColors?.backgroundColor) {
        setBackgroundColor(themeColors?.backgroundColor);
      }
      if (themeColors?.color) {
        setColor(themeColors?.color);
      }
      if (themeColors?.ctaOne) {
        setCtaOne(themeColors?.ctaOne);
      }
      if (themeColors?.ctaTwo) {
        setCtaTwo(themeColors?.ctaTwo);
      }
      if (themeColors?.iconColor) {
        setIconColor(themeColors?.iconColor);
      }
      if (themeColors?.accordionIconColor) {
        setAccordionIconColor(themeColors?.accordionIconColor);
      }
      if (themeColors?.theme) {
        setTheme(themeColors?.theme);
      }
    };
    if (themeColors) {
      updateThemeColors();
    }
  }, [themeColors]);
  return {
    backgroundColor,
    color,
    ctaOne,
    ctaTwo,
    iconColor,
    accordionIconColor,
    theme
  };
};
var _default = useStyles;
exports.default = _default;